import React, { useState } from "react";
import { WeatherBar } from "./WeatherBar";
import { useSelector } from "react-redux";
import { Button, makeStyles } from "@material-ui/core";
import { ChevronLeft, CloudCircle} from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
  btnShow: {
    color: "#666666",
    backgroundColor: "#a5c2dd",
    marginRight: "5px",
    height: "120px",
  },
  barVisible: {
    transform: 'translateX(0)',
    transition: 'transform 0.3s ease-in-out',
  },
  barHidden: {
    transform: 'translateX(-150%)',
    transition: 'transform 0.3s ease-in-out',
  },
}));

export const RenderBar = () => {
  const auth = useSelector((state) => state.auth);
  const gis = useSelector((state) => state.gis);
  const classes = useStyles();

  const isShowWheatear = auth.clima === "True";
  const isGisBarEmpty = gis.dataBar !== null;
  const [isBarVisible, setIsBarVisible] = useState(true);
  const isShowBar = isShowWheatear && isGisBarEmpty ;
  const handleToggleBar = () => {
    setIsBarVisible(!isBarVisible);
  };

  return (
    <div
      style={{
        display: "flex",
      }}
    >
      <Button
        onClick={handleToggleBar}
        className={classes.btnShow}
        disabled={!isGisBarEmpty}
      >
        {isBarVisible ? <ChevronLeft /> : <CloudCircle />}
      </Button>
      <div className={isBarVisible ? classes.barVisible : classes.barHidden}>
        {isShowBar && <WeatherBar />}
      </div>
    </div>
  );
};
